import React, { Component } from 'react';

class Hireology extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }

  componentDidMount() {
    this.mounted = true;

    this.hireSnippet().then(() => {
      if (this.mounted) {
        const widget = new CareerWidget(this.props.data.url, document);
        const parentOptions = window.location.search;
        widget.addSocket(widget.url(false, parentOptions));
      }
    });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  hireSnippet() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');

      Object.assign(script, {
        src: 'https://app.hireology.com/javascripts/jobs.js',
      });
      script.addEventListener('load', () => {
        resolve();
      });
      script.addEventListener('error', (e) => {
        reject(e);
      });

      this.myRef.current.appendChild(script);
    });
  }

  render() {
    return (
      <>
        <div ref={this.myRef} />
        <div id="hireology_iframe" />
      </>
    );
  }
}

export default Hireology;
